import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Tooltip } from 'reactstrap'
import EditLogin from './EditLogin'
import EditName from './EditName'
import Delete from './Delete'
import SubAccount from './SubAccount'
import Loading from '../../common/Loading'
import ResumeSuspended from './ResumeSuspended'
import Answer from './Answer'
import ConfirmSuspend from './ConfirmSuspend'
import BankHeader from './BankHeader'
import {mapDispatchToProps} from "../../mapDispatchToProps"
import $ from 'jquery'
import UIlHelper from '../../../util/ui-helper'
import { trackingEvent } from "../../pages/layouts/GoogleAnalytics.js"

class BankItem extends React.Component {
  _isMounted = false

  constructor(props) {
    super(props)

    this.toggleSetting = this.toggleSetting.bind(this)
    this.toggleList = this.toggleList.bind(this)
    this.toggleTooltip = this.toggleTooltip.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.reloadAccount = this.reloadAccount.bind(this)
    this.intervalLoadAccount = null
    this.countLoadAccount = 0
    this.highlightTimeout = null

    this.state = {
      isOpenModal: false,
      toggleSetting: false,
      toggleList: true,
      currentModal: null,
      isProcessing: true,
      syncState: false,
      tooltipOpen: false,
      tooltipMouseOut: false
    }
  }

  trackingSync() {
    trackingEvent("Bank", "更新")
    onclick = !this.state.syncState? this.getData() : undefined
  }

  trackingCloseSubAccounts() {
    trackingEvent("Bank", "口座一覧を閉じる")
    this.toggleList()
  }

  toggleSetting() {
    this.setState({
      toggleSetting: !this.state.toggleSetting
    });
  }

  toggleList() {
    this.setState({
      toggleList: !this.state.toggleList
    });
  }

  toggleModal(currentModal = null) {
    let isOpenModal = typeof(currentModal) === 'string'  ? true : !this.state.isOpenModal

    this.setState({isOpenModal: isOpenModal, currentModal: currentModal})
  }

  componentDidMount() {
    const {id} = this.props.item
    this._isMounted = true

    this.props.accountActions.subAccountList(id).then(res => {
      this.props.accountActions.accountShow(id)
      this._isMounted && this.setState({
        isProcessing: false
      })
    })
  }

  componentDidUpdate(){
    // Create interval reload account for suspend case
    this.checkReloadAccount()
    this.props.selectedAccount.accountId && this.handleHighlightSelectedAccount()
  }

  componentWillUnmount(){
    // Clear interval in case delete account
    this.endReloadAccount()
    this._isMounted = false
  }

  checkReloadAccount(){
    const { status } = this.props.item

    if(!this.intervalLoadAccount && status && status.code === 1){
      this.intervalLoadAccount = setInterval(this.reloadAccount, 10000)
    }
  }

  reloadAccount() {
    this.props.accountActions.accountShow(this.props.item.id).then(() => {
      this.countLoadAccount += 1

      if(this.props.item.status && (this.props.item.status.code !== 1 || this.countLoadAccount >= 10))
        this.endReloadAccount()
    })
  }

  endReloadAccount() {
    clearInterval(this.intervalLoadAccount)
    this.intervalLoadAccount = null
    this.countLoadAccount = 0
  }

  handleHighlightSelectedAccount(){
    if(!this.highlightTimeout && this.props.item.id === this.props.selectedAccount.accountId) {
      this.highlightTimeout = setTimeout(() => {
        // Scroll to selected account
        if(this.props.selectedAccount.isScrollTo && this.refs.bankContainer){
          window.scrollTo(0, this.refs.bankContainer.offsetParent.offsetTop - 10)
        }

        // Highlight selected account
        const el = $('.highlight')[0]
        if(el){
          UIlHelper.highlightEl(el, () => this.handleAfterHighlighted())
          el.classList.remove("highlight")
        }
      }, this.props.selectedAccount.delayHighlightTime)
    }
  }

  handleAfterHighlighted() {
    this.props.accountActions.accountSelect(null)
    clearTimeout(this.highlightTimeout);
    this.highlightTimeout = null
  }

  render_subs() {
    const sub_accounts = (this.props.item.sub_accounts && this.props.item.sub_accounts.sub_accounts) || []
    const length = sub_accounts.length

    return (
      <div className="row item-body">
        {this.state.isProcessing ? <Loading className="progress" /> :
          sub_accounts.map((row, i) => <SubAccount key={i} item={row} account={this.props.item} hasBottomLine={i !== (length -1)} />)}
      </div>
    )
  }

  suspend() {
    const {is_suspended, service, identifiable_code} = this.props.item

    if (is_suspended) {
      if (service.requires_provider_auth) { // case account using AccountWeb
        this.props.screenActions.screenLoadingModal(true);
        this.props.accountActions.editLoginService(service.id, identifiable_code, this.props.userEmail)
      } else { // Case account not using AccountWeb
        this.toggleModal('resumeSuspended')
      }
    } else {
      this.toggleModal('confirmSuspend')
    }
  }

  getData() {
    this.setState({syncState: true})
    Promise.all([
      this.props.aggregate([this.props.item.id])
    ]).then(() => {
      setTimeout(() => this.setState({syncState: false}), 1000)
    })
  }

  accountName() {
    let {display_name, service} = this.props.item

    if(!display_name)
      display_name = service && service.name

    return display_name && display_name.substring(0, 50)
  }

  handleEditLogin() {
    const {service, identifiable_code} = this.props.item

    if(service.requires_provider_auth)
      this.props.accountActions.editLoginService(service.id, identifiable_code, this.props.userEmail)
    else
      this.toggleModal('editLogin')
  }

  renderTooltipEditLogin() {
    const {id} = this.props.item
    return <Tooltip placement="top" isOpen={this.state.tooltipOpen} target={`notice_edit_${id}`} toggle={this.toggleTooltip}>
      {i18n.t('bank.item_bank.status_messages.acquired')}
    </Tooltip>
  }

  toggleTooltip(event) {
    if(event.type === "mouseover"){
      setTimeout(() => {
        !this.state.tooltipMouseOut && this.setState({
          tooltipOpen: true
        })
      }, 300)
    } else {
      this.setState({
        tooltipOpen: false
      })
    }
  }

  render() {
    const {id, is_suspended, error, status, service} = this.props.item
    if(!id || !error || !service) {
      return <div className="text-center"><Loading className="fa-3x" /></div>;
    }

    const sub_accounts = (this.props.item.sub_accounts && this.props.item.sub_accounts.sub_accounts) || []
    let icon = null
    const isEnableRefresh = status.code === 0 && !service.is_mfsc && !is_suspended
    const hasNoSubaccount = sub_accounts.length === 0
    const isNotShowItems = hasNoSubaccount || !this.state.toggleList
    const isDisabledEditLogin = status.code === 1

    icon = isEnableRefresh
      ? <i onClick={() => this.trackingSync()} className="fas fa-sync-alt" id={`notice_refresh_${id}`}></i>
      : <i className={`fas fa-sync-alt is_mfsc mfc-icon-disable`} id={`notice_refresh_${id}`}></i>

    const noDataClass = !this.state.isProcessing && isNotShowItems ? 'no-data' : ''
    const highlightClass = this.props.selectedAccount.accountId === id ? 'highlight': ''

    return (
      <div className="row no-gutters">
        <div className="col-sm-12 content-body">
          <div ref="bankContainer" className={`item-bank ${noDataClass} ${highlightClass}`}>
            <div className="row item-header">
              <div className="col-sm-12">
                <p className="title">{this.accountName()}</p>
                <div className="icons-right">
                  <span onMouseOver={() => this.setState({tooltipMouseOut: false})} onMouseOut={() => this.setState({tooltipMouseOut: true})}>{icon}</span>
                  <ButtonDropdown direction="right" isOpen={this.state.toggleSetting} toggle={this.toggleSetting} >
                    <DropdownToggle>
                      <i id="caret" onClick={() => trackingEvent("Bank", "アカウント設定")} className={`fas fa-cog ${this.state.toggleSetting ? 'fa-cog-open' : ''}`}></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => {trackingEvent("Bank", "表示名を編集"); this.toggleModal('editName')}}>{i18n.t('bank.settings.edit_name')}</DropdownItem>
                      <hr/>
                      {!is_suspended &&
                        <div id={isDisabledEditLogin ? `notice_edit_${id}`: ''} onMouseOver={() => this.setState({tooltipMouseOut: false})} onMouseOut={() => this.setState({tooltipMouseOut: true})}>
                          <DropdownItem disabled={isDisabledEditLogin} onClick={() => { trackingEvent("Bank", "ログイン情報を編集"); this.handleEditLogin()}}>{i18n.t('bank.settings.edit_login')}</DropdownItem>
                          <hr/>
                          {isDisabledEditLogin && this.renderTooltipEditLogin()}
                        </div>}
                      <DropdownItem onClick={() => {trackingEvent("Bank", "データ取得を停止");this.suspend()}}>
                        {i18n.t(`${is_suspended ? 'bank.settings.resume_get_data' : 'bank.settings.stop_get_data'}`)}
                      </DropdownItem>
                      <hr/>
                      <DropdownItem onClick={() => { trackingEvent("Bank", "口座を削除"); this.toggleModal('deleteAccount')} }>{i18n.t('bank.settings.delete_bank')}</DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                </div>
              </div>
              <div className="col-sm-12 boder-box box-date">
                {!this.state.isProcessing &&
                <BankHeader
                  account={this.props.item}
                  toggleModal={this.toggleModal}
                  isSyncing={this.state.syncState || this.props.syncing}
                  tooltipMouseOut={this.state.tooltipMouseOut}
                  isEnableRefresh={isEnableRefresh}
                  setHighlight={this.setHighlight}
                />}
                {!hasNoSubaccount && <div className="pull-right" onClick={() => { this.trackingCloseSubAccounts()}}>
                  <div className={`dropdown ${isNotShowItems ? 'down' : ''}`}>
                    <span>
                      {i18n.t(`${isNotShowItems ? 'bank.toggle_bank_down' : 'bank.toggle_bank_up'}`)}
                    </span>
                  </div>
                </div>}
              </div>
            </div>

            {this.state.toggleList && this.render_subs()}
            {this.state.currentModal==='editLogin' && <EditLogin isOpen={this.state.currentModal==='editLogin'} toggle={this.toggleModal} account={this.props.item}/>}
            {this.state.currentModal==='editName' && <EditName isOpen={this.state.currentModal==='editName'} toggle={this.toggleModal} account={this.props.item}/>}
            {this.state.currentModal==='deleteAccount' && <Delete isOpen={this.state.currentModal==='deleteAccount'} toggle={this.toggleModal} account={this.props.item} onDeleted={this.props.onDeleted} />}
            {this.state.currentModal=== 'resumeSuspended' && <ResumeSuspended isOpen={this.state.currentModal==='resumeSuspended'} toggle={this.toggleModal} account={this.props.item} onResumeSuspended={this.props.onResumeSuspended} />}
            {this.state.currentModal=== 'answer' && <Answer isOpen={this.state.currentModal==='answer'} toggle={this.toggleModal} account={this.props.item}/>}
            {this.state.currentModal=== 'confirmSuspend' && <ConfirmSuspend isOpen={this.state.currentModal==='confirmSuspend'} toggle={this.toggleModal} account={this.props.item} onSuspended={this.props.onSuspended} />}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail: state.user.get('email'),
    highlightAccountId: state.user.get('highlightAccountId'),
    selectedAccount: state.user.get('selectedAccount'),
    lastAction: state.lastAction
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BankItem)
